import React, { useContext, useState } from "react";
import { css } from "@emotion/react";
import PropTypes from "prop-types";

import TextInput from "./textInput";
import Button from "./button";
import Link from "./link";

import { baseColor2, baseColor1, logoColor3 } from "../styles/color";
import { breakpointMd, breakpointSm } from "../styles/layout";
import { OpenInNewRounded } from "@mui/icons-material";
import { AmplitudeContext } from "../context/amplitude";

const formStyles = css`
  display: flex;
  flex-wrap: wrap;
  margin-top: 1.5rem;

  .inputs {
    display: flex;
    gap: 0.75rem;
    width: 100%;
    margin: 0 0 10px 0;
    max-width: 450px;
  }

  .break {
    flex-basis: 100%;
    height: 0;
  }

  .revue-form-footer {
    margin-top: 0.5rem;
  }

  @media only screen and (max-width: ${breakpointSm}) {
    display: flex;
    flex-direction: column;

    .inputs {
      width: 100%;
      display: grid;
      gap: 0.75rem;
    }

    .subscribe {
      width: 100%;
      max-width: 450px;

      button {
        width: 100%;
      }
    }
  }
`;

const jobPostingStyles = css`
  // Reuse existing styles
  ${formStyles}

  // Override styles to support job posting
  .inputs {
    display: grid;
    margin: 0;
    max-width: unset;
  }

  .subscribe {
    max-width: unset;
  }

  @media only screen and (min-width: ${breakpointSm}) {
    .inputs {
      display: flex;
    }
  }

  @media only screen and (min-width: ${breakpointMd}) {
    .inputs {
      display: grid;
    }
  }
`;

const RevueNewsletter = (props) => {
  const [email, setEmail] = useState("");

  const monitor = useContext(AmplitudeContext);

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  if (props.newsletterLocation === "job posting") {
    return (
      <form
        css={jobPostingStyles}
        className="form"
        action="https://www.getrevue.co/profile/joinonework/add_subscriber"
        method="post"
        id="revue-form"
        name="revue-form"
        target="_blank"
      >
        <div className="inputs">
          <TextInput
            type="email"
            placeholder="lara@onework.co"
            fullWidth
            value={email}
            onChange={handleEmail}
            name="member[email]"
          />
          <div className="subscribe">
            <Button
              text="Subscribe"
              icon={<OpenInNewRounded />}
              type="submit"
              bgColor={logoColor3}
              color={baseColor2}
              fullWidth={true}
              onClick={() => {
                monitor.logEvent("NEWSLETTER SUBSCRIBE BUTTON CLICKED", {
                  buttonLocation: props.newsletterLocation,
                });
              }}
            />
          </div>
        </div>
      </form>
    );
  } else {
    return (
      <form
        css={formStyles}
        className="form"
        action="https://www.getrevue.co/profile/joinonework/add_subscriber"
        method="post"
        id="revue-form"
        name="revue-form"
        target="_blank"
      >
        <div className="inputs">
          <TextInput
            type="email"
            placeholder="lara@onework.co"
            fullWidth
            value={email}
            onChange={handleEmail}
            name="member[email]"
          />
          <div className="subscribe">
            <Button
              text="Send me jobs"
              icon={<OpenInNewRounded />}
              type="submit"
              bgColor={logoColor3}
              color={baseColor2}
              fullWidth={true}
              onClick={() => {
                monitor.logEvent("NEWSLETTER SUBSCRIBE BUTTON CLICKED", {
                  buttonLocation: props.newsletterLocation,
                });
              }}
            />
          </div>
        </div>
        <div className="break"></div>
        <div className="revue-form-footer">
          By subscribing, you agree with Revue's{" "}
          <Link
            to="https://www.getrevue.co/terms"
            color={props.linkColor}
            external={true}
          >
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link
            to="https://www.getrevue.co/privacy"
            color={props.linkColor}
            external={true}
          >
            Privacy Policy
          </Link>
          .
        </div>
      </form>
    );
  }
};

RevueNewsletter.defaultProps = {
  newsletterLocation: "home page",
  linkColor: baseColor1,
};

RevueNewsletter.propTypes = {
  newsletterLocation: PropTypes.string,
  linkColor: PropTypes.string,
};

export default RevueNewsletter;
